// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: fromInt,
  fromString: Id_fromString,
  toInt: toInt,
  toString: Id_toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

function parse$1(value) {
  return {
          id: Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, value.id),
          name: value.name
        };
}

function serialize(value) {
  var value$1 = value.name;
  var value$2 = value.id;
  var value$3 = Curry._1(toInt, value$2);
  return {
          id: value$3,
          name: value$1
        };
}

function verifyArgsAndParse(_CommonTypes_ShiftType_Accessory, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function toString(param) {
  return param.name;
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var Ord = {
  compare: compare$1,
  eq: eq$1
};

var $$Set = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var $$Map = Relude_Map.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var query = "fragment CommonTypes_ShiftType_Accessory on Accessory   {\nid  \nname  \n}\n";

exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.toString = toString;
exports.compare = compare$1;
exports.eq = eq$1;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.$$Map = $$Map;
/* include Not a pure module */
